import { atom } from "recoil";
import { ICampaignsUsedInTags } from "../api/Tags";
import { ITag } from "../types/TagTypes";

export const TagsAtom = atom<ITag[]>({
  key: "Tags",
  default: [],
});

export const IsCheckedAllTagsAtom = atom<boolean>({
  key: "IsCheckedAllTagsAtom",
  default: false,
});

export const CampaignsUsedInTagsAtom = atom<Array<ICampaignsUsedInTags>>({
  key: "CampaignsUsedInTagsAtom",
  default: [],
});
